<template>
  <!-- NOTE: HOME画面 -->
  <v-ons-page>
    <v-ons-splitter>
      <v-ons-splitter-side
        width="480px"
        collapse=""
        side="left"
        class="splitter"
        :open.sync="isShowMenu"
      >
        <home-menu />
      </v-ons-splitter-side>

      <v-ons-splitter-content>
        <home-index />
      </v-ons-splitter-content>
    </v-ons-splitter>
  </v-ons-page>
</template>

<script>
import homeMenu from './menu.vue';
import homeIndex from './index.vue';

export default {
  components: {
    homeMenu,
    homeIndex,
  },
  computed: {
    isShowMenu: {
      get: ({ $store }) => $store.state.homeNavigator.isShowMenu,
      set(value) {
        this.$store.commit('homeNavigator/toggleMenu', value);
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// splitter.vue?5d8486c5